import { IReflect } from '../interfaces/reflect.interface';

export class FormReflect implements IReflect {

  affectedField: string;
  applyRegex: string;
  regexToSet: string;
  requiredPath: string;
  requiredToSet: boolean;
  styleClass: string;
  styleClassPath: string;
  valuePath: string;
  valueToSet: string;
  checkOnInit: boolean;
  applyNumericCheck?: { min?: number, max?: number};
  options: { values?: Array<any>, resource?: string};

  protected constructor(affectedField: string) {
    this.affectedField  = affectedField;
    return this;
  }

  public static builder(affectedField: string) {
    return new FormReflect(affectedField);
  }

  public setApplyRegex(regex: string) {
    this.applyRegex = regex;
    return this;
  }

  public setNumbericCheck(min?: number, max?: number) {
    this.applyNumericCheck = { min, max};
    return this;
  }

  public setRegex(regex: string) {
    this.regexToSet = regex;
    return this;
  }

  public setRequire(require: boolean) {
    this.requiredToSet = require;
    return this;
  }

  public setRequirePath(requiredPath: string) {
    this.requiredPath = requiredPath;
    return this;
  }

  public setStyleClass(styleClass: string) {
    this.styleClass = styleClass;
    return this;
  }

  public setStyleClassPath(styleClassPath: string) {
    this.styleClassPath = styleClassPath;
    return this;
  }

  public setValuePath(valuePath: string) {
    this.valuePath = valuePath;
    return this;
  }

  public setValue(value: any) {
    this.valueToSet = value;
    return this;
  }

  public setCheckOnInit(value: boolean) {
    this.checkOnInit = value;
    return this;
  }
}
